<template>
  <div class="container liu-hai-pin">
    <div class="inner-container-box">
      <navComp :navList="tabNavList" :activeTab.sync="activeTab" />
      <indexPage
        v-if="activeTab == 'index'"
        @switchTab="
          (tab) => {
            activeTab = tab;
          }
        "
      />
      <clubPage v-if="activeTab == 'club'" />
      <livePage v-if="activeTab == 'live'" />
      <newsPage v-if="activeTab == 'news'" />
    </div>
  </div>
</template>

<script>
import {
  getDict,
  getPageDictInit,
  axios,
  formatDate,
  getPageLevelMixin,
} from "../../common";
import { mapState, mapGetters } from "vuex";
import store from "@/store";
import navComp from "./comps/nav";
import indexPage from "./page/indexPage";
import clubPage from "./page/club";
import livePage from "./page/live";
import newsPage from "./page/news";

const getPageDict = getPageDictInit("eSport");

export default {
  name: "eSportPage",
  mixins: [getPageLevelMixin],
  components: {
    navComp,
    indexPage,
    clubPage,
    livePage,
    newsPage,
  },
  data() {
    return {
      tabNavList: [
        {
          key: "index",
          name: getPageDict(1),//"首页",
        },
        {
          key: "club",
          name: getPageDict(2),//"俱乐部",
        },
        {
          key: "live",
          name: getPageDict(3),//"LIVE",
        },
        {
          key: "news",
          name: getPageDict(4),//"资讯",
        },
      ],
      activeTab: "index",
    };
  },
  computed: {
    /* ...mapState({
      clubList: (state) => state.clubPage.clubList,
    }),
    ...mapGetters({
      curClub: "clubPage/curClub",
    }), */
  },
  watch: {},
  methods: {
    getDict,
    getPageDict,
  },

  mounted() {},
  created() {
    if (this.$route.params && this.$route.params.tab) {
      if (
        this.tabNavList.find((tabObj) => tabObj.key == this.$route.params.tab)
      ) {
        this.activeTab = this.$route.params.tab;
        if (this.$route.params.itemId) {
          this.$store.dispatch(
            "clubPage/switchCurClub",
            this.$route.params.itemId
          );
        }
      }
    }
  },
};
</script>

  <style lang="scss" scoped>
.container {
  display: flex;
  flex: 1;
  // height: 100%;
  position: relative;

  justify-content: center;
  align-items: center;

  .inner-container-box {
    // background-color: rgba(0, 0, 0, 0.2);
    width: 12.71rem;
    height: 5.38rem;
    display: flex;
    flex-direction: column;
  }
}
</style>
